module.exports = __webpack_public_path__ + "static/img/product5-1.75e62c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product5-1.jpg
// module id = 68MM
// module chunks = 0